'use strict'

import { createElements, createHtmlElement, userPrevent } from '../../functions';
import gsap from "gsap";
import { contactsData } from './contactUsConfig';
import {isMobile} from "../../settings";
import {changeLangToCurrent, getCurrentLang, isDesktopMode} from '../language/langSwitcher';
import {mobileBurgerStyleToggle} from "../menu/menu";
import {changePlaceholder, customiseForm, moveFormToBlock, setTranslateToSendBtn} from "../form/form";
import {addScripts, scriptsChecker} from "../widgets/poi/poiv3";
import { settingsData } from '../../settings';
import { ViewMode } from '../../common';
import { openSearchHandler } from '../search/search';
import { setMenuActive } from '../menu/menu';
import { closeContactWidget } from '../chats/chats';

let data = null;

export async function getContactsDataFromAPI () {
    data = await contactsData();
}

export const openContactUs = async () => {

    closeContactWidget();

    const contactUsBlock = createElements('div', ['contact-us', 'no-canvas'], document.body);

    if (config.general.leadForm || settingsData.isConferenceHost)  {
        customiseForm(document.querySelector('.form__container-main'));
    }
    // Create elements

    // const textContactUs = createElements('div', ['contact-us__text', 'language-string'], contactUsBlock);
    const titleContactUs = createElements('h2', ['contact-us__title'], contactUsBlock);
    // const titleContactUs = createElements('h2', ['contact-us__title', 'language-string'], contactUsBlock);
    const closeButtonContactUs = createElements('button', ['contact-us__close-button', 'button', 'icon-close'], contactUsBlock);
    const previewContactUs = createElements('div', ['contact-us__preview'], contactUsBlock);
    const textContactUs = createElements('div', ['contact-us__text'], contactUsBlock);
    const contactsContactUs = createElements('div', ['contact-us__contacts'], contactUsBlock);
    const buttonsContactUs = createElements('div', ['contact-us__buttons'], contactUsBlock);

    // Set content to elements

    addTitle(titleContactUs, data);
    addText(textContactUs, data);

    const scriptInterval = setInterval(()=>{
        addScripts();
        if (scriptsChecker()){
            clearInterval(scriptInterval);
            addMap(previewContactUs, data);
        }
    },200);

    // addMap(previewContactUs, data);
    addContacts(contactsContactUs, data);

    addButtons(buttonsContactUs, data);

    // ADD Form

    if (config.general.leadForm || settingsData.isConferenceHost)  {
        const form = document.querySelector('.form__container-main');
        moveFormToBlock(contactsContactUs, 'afterend');
        setTranslateToSendBtn(form);
        changePlaceholder(form);
    }

    closeButtonContactUs.addEventListener('click', removeContactUs, {once: true})

    if (!isMobile){
        openAndCloseAnimation('open');
    }

    // const substrate = createHtmlElement(document.body, '', 'div', ['contact-us__substrate']);
}

export const removeContactUs = (speed) => {
    const contactUsBlock = document.querySelector('.contact-us');

     moveFormToBlock();

    if (speed === 'immediately') {
        document.body.removeChild(contactUsBlock);
        return;
    }

    if (contactUsBlock){
        openAndCloseAnimation('close');
        if (settingsData.activeViewMode === ViewMode.Cylinder || settingsData.activeViewMode === ViewMode.FloorPlan ){
            if (!isMobile){
                openSearchHandler();
            }
            setMenuActive('search')
        } else if (settingsData.activeViewMode === ViewMode.Orbit){
            setMenuActive('3dModel')
        }
    }
};

export const changeContactUsModulePosition = () => {
    const mainContainer = document.querySelector('.contact-us');

    if (!mainContainer) return;

    const menuContainer = document.querySelector('.aside__container');
    const currentDirection = document.documentElement.getAttribute('dir');
    const menuContainerWidth = +menuContainer.getAttribute('data-initial-width');

    switch (currentDirection) {
        case 'rtl': {
            mainContainer.removeAttribute('style');
            mainContainer.setAttribute('style', `right:${menuContainerWidth}px`);
            break;
        }
        case 'ltr': {
            mainContainer.removeAttribute('style');
            mainContainer.setAttribute('style', `left:${menuContainerWidth}px`);
            break;
        }
        default:
            break;
    }

    removeContactUs('immediately');
    openContactUs();
}

export const openAndCloseAnimation = (action) => {
    const contactUsBlock = document.querySelector('.contact-us');
    const importantDirection = isDesktopMode();
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    let menuWidth = document.querySelector('.aside__container').getBoundingClientRect().width;
    let menuHeight = document.querySelector('.aside__container').getBoundingClientRect().height;

    if (importantDirection){
        menuWidth = 0;
    }

    const tl = gsap;
    const direction = {};

    switch (action) {
        case 'open':
            if (importantDirection){
                direction.from = {
                    left:  'initial',
                    right: '-100%',
                    height: `${window.innerHeight - menuHeight}px`
                };
                direction.to = {
                    left: 'initial',
                    right: `${menuWidth}px`,
                    height: `${window.innerHeight - menuHeight}px`
                };

            } else {
                direction.from = {
                    left: rtl ? 'initial' : '-100%',
                    right: rtl ? '-100%' : 'initial',
                    height: `${menuHeight}px`
                };
                direction.to = {
                    left: rtl ? 'initial' : `${menuWidth}px`,
                    right: rtl ? `${menuWidth}px` : 'initial',
                    height: `${menuHeight}px`
                };
            }
            break;
        case 'close':
            if (importantDirection){
                direction.from = {
                    left:  'initial',
                    right: `${menuWidth}px`,
                    height: `${window.innerHeight - menuHeight}px`,
                };
                direction.to = {
                    left: 'initial',
                    right: `-100%`,
                    height: `${window.innerHeight - menuHeight}px`,
                    complete: true
                };
            } else {
                direction.from = {
                    left: rtl ? 'initial' : `${menuWidth}px`,
                    right: rtl ? `${menuWidth}px` : 'initial',
                    height: `${menuHeight}px`,
                };
                direction.to = {
                    left: rtl ? 'initial' : '-100%',
                    right: rtl ? '-100%' : 'initial',
                    height: `${menuHeight}px`,
                    complete: true,
                };
            }
            break;
    }

    return new Promise(resolve => {
        tl.fromTo(contactUsBlock,  {
            left: direction.from.left,
            right: direction.from.right,
            height: direction.to.height,
            direction: .5,
        }, {
            left: direction.to.left,
            right: direction.to.right,
            height: direction.to.height,
            direction: .5,
            onStart: ()=>{
                userPrevent(true);
            },
            onComplete: () => {
                if (direction.to.complete) {
                    substrateToggle('hide');
                    contactUsBlock.parentNode !== null && document.body.removeChild(contactUsBlock);
                    isMobile && mobileBurgerStyleToggle();
                } else {
                    substrateToggle('show');
                }
                userPrevent(false);
                resolve();
            },
        });

    });


}

function substrateToggle (action) {
    const substrate = document.querySelector('.aside__open-menu__substrate');

    switch (action) {
        case 'hide': substrate.classList.remove('substrate__show');
            break;
        case 'show': substrate.classList.add('substrate__show');
            break;
    }
}

const addTitle = (parent, data) => {
    const title = data.find(item => item.title === 'title')?.crmData;
    if (title){
        parent.innerText = title[getCurrentLang()];
    }
}

const addText = (parent, data) => {
    const text = data.find(item => item.title === 'text')?.crmData;
    if (text){
        parent.innerText = text[getCurrentLang()];
    }
}

const addMap = (parent, data) => {
    const mapContainer = createElements('div', ['contact-us__map'], parent);
    const coordinates = data.find(item => item.title === 'map')?.crmData;

    // const uluru = coordinates;
    // The map, centered at Uluru
    if (coordinates){
        const map = new google.maps.Map(mapContainer, {
            zoom: 15,
            center: { lat: Number(coordinates.latitude), lng: Number(coordinates.longitude)},
        });
        // The marker, positioned at Uluru
        const marker = new google.maps.Marker({
            position: { lat: Number(coordinates.latitude), lng: Number(coordinates.longitude)},
            map: map,
        });
    }
}

// const addButtons = (parent, data) => {
//     const phone = data.find(item => item.title === 'phones').crmData;
//     const chatUrl = data.find(item => item.title === 'chatUrl').crmData;
//
//     const buttonChat = createElements('button', ['contact-us__buttons-btn', 'button'], parent);
//     const buttonCall = createElements('button', ['contact-us__buttons-btn', 'button'], parent);
//
//     // buttonChat.innerText = 'Chat with manager';
//     // buttonCall.innerText = phone;
//
//     buttonChat.innerHTML = `<span class='icon-chat'></span><span class="contact-us__buttons-chat language-string" data-dictionary="Chat with manager">${changeLangToCurrent('Chat with manager')}</span>`;
//     buttonCall.innerHTML = `<span class='icon-call'></span><span class="contact-us__buttons-call">${phone}</span>`;
//
//     addCallListener(phone);
//     addChatListener(chatUrl);
// }

const addButtons = (parent, data) => {
    const phone = data.find(item => item.title === 'phones')?.crmData;
    const chatUrl = data.find(item => item.title === 'chatUrl')?.crmData;

    const buttonCall = createElements('button', ['contact-us__buttons-btn', 'button'], parent);
    buttonCall.innerHTML = `<span class='icon-call'></span><span class="contact-us__buttons-call">${phone}</span>`;
    addCallListener(phone);

    const buttonChat = createElements('button', ['contact-us__buttons-btn', 'button'], parent);
    buttonChat.innerHTML = `<span class='icon-chat'></span><span class="contact-us__buttons-chat language-string" data-dictionary="Chat with manager">${changeLangToCurrent('Chat with manager')}</span>`;
    addChatListener(chatUrl);

    if (!chatUrl) buttonChat.style.display = 'none';
    if (!phone) buttonCall.style.display = 'none';
}



const addCallListener = (phone) => {
    const callBtn = document.querySelector('.contact-us__buttons-call');

    callBtn.addEventListener('click', () => {
        window.location.href = 'tel:' + phone;
    });
}

const addChatListener = (chatUrl) => {
    const chatBtn = document.querySelector('.contact-us__buttons-chat');

    chatBtn.addEventListener('click', () => {
        window.open(chatUrl);
    });
}

const addContacts = (parent, data) => {
    const contactsArray = ['phones', 'website', 'emails'];

    const contactsList = createElements('ul', ['contact-us__contacts-list'], parent);

    data.forEach(item => {
        const object = contactsArray.find(elem => elem === item.title);
        if (!object) return;
        const element = createElements('li', ['contact-us__contacts-list--item', `contacts-us__item--${item.title}`, `${item.icon}`], contactsList);

        if (item.title === 'website') {
            element.innerHTML = `<a href="${item.crmData}" class="contact-us__item--website-link language-string" target="_blank" data-dictionary=${item.title}>${!isMobile ? item.crmData : changeLangToCurrent(item.title)}</a>`;
        } else if (item.title === 'phones') {
            element.innerHTML = `<a href="tel:${item.crmData}" class="contact-us__item--phone-link">${item.crmData}</a>`;
        } else if (item.title === 'emails') {
            element.innerHTML = `<a href="mailto:${item.crmData}" class="contact-us__item--email-link">${item.crmData}</a>`;
        }

        // item.title === 'website'
        //     ? element.innerHTML = `<a href="${item.crmData}"
        //                               class="contact-us__item--website-link language-string"
        //                               target="_blank"
        //                               data-dictionary=${item.title}
        //                           >${changeLangToCurrent(item.title)}</a>`
        //     : element.innerText = `${item.crmData}`;

    });

    if (data.length > 2 && !isMobile) {
        contactsList.style.gridTemplateColumns = '1fr';
    }
}

/**
 * Handlers
 */

// const phoneClickHandler = () => {
//
// }

/**
 * Remove listeners
 */